import { alpha, useTheme } from '@mui/material';
const useSettingsStyles = () => {
    const theme = useTheme();
    const headerHeight = '48px';
    const bottomNavigationHeight = '56px';
    return {
        sectionStyles: {
            display: 'flex',
            flexDirection: 'column',
            p: 2,
            height: `calc(100dvh - ${headerHeight} - ${bottomNavigationHeight})`,
            overflowY: 'auto',
            position: 'relative',
        },
        statusInfoContainerStyles: {
            display: 'flex',
            flexDirection: 'column',
            gap: 1,
        },
        statusCardStyles: {
            p: 1,
            display: 'flex',
            flexDirection: 'column',
            gap: 0.5,
            flex: '1 0 0',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: 1,
            height: 66,
        },
        settingsContainerStyles: {
            display: 'flex',
            flexDirection: 'column',
            mt: 2,
            gap: 1,
        },
        navigationTilesContainerStyles: {
            display: 'flex',
            flexDirection: 'column',
            gap: 1,
        },
        logoutButtonStyles: {
            backgroundColor: alpha(theme.palette.error.main, 0.08),
            mt: 'auto',
            mb: 1,
        }
    };
};
export default useSettingsStyles;
